import { SPACELIFT_VCS_REPO_FILES_COLUMN_ID } from "../constants";
import NameCell from "./NameCell";
import CommitCell from "./CommitCell";
import LastCommitCell from "./LastCommitCell";
import UpdatedAtCell from "./UpdatedAtCell";
import RowActionsCell from "./RowActionsCell";

export const SPACELIFT_VCS_REPO_FILES_CELLS = {
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.NAME]: NameCell,
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT]: CommitCell,
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.COMMIT_MESSAGE]: LastCommitCell,
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.UPDATED_AT]: UpdatedAtCell,
  [SPACELIFT_VCS_REPO_FILES_COLUMN_ID.DROPDOWN]: RowActionsCell,
};
